module.exports = __webpack_public_path__ + "img/s10.13629634.svg";